import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<g clip-path=\"url(#a)\"><path fill=\"#F0F0F0\" d=\"M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12\"></path><path fill=\"#A2001D\" d=\"M12 0C6.84 0 2.442 3.255.746 7.824h22.507C21.558 3.255 17.16 0 12 0\"></path><path fill=\"#000\" d=\"M12 24c5.16 0 9.558-3.256 11.253-7.825H.746C2.442 20.745 6.84 24 12 24\"></path><path fill=\"#496E2D\" d=\"M9.132 11.218H6.82c.116-.449.524-.782 1.009-.782V8.87a2.61 2.61 0 0 0-2.609 2.608v1.305h3.914c.143 0 .26.117.26.26v.522H4.176v1.566h6.782v-2.088c0-1.006-.819-1.826-1.826-1.826M13.046 13.566V8.87H11.48v6.26h2.608v-1.565zM18.262 13.566V8.87h-1.566v4.696h-.521V12h-1.566v3.13h4.696v-1.564z\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h24v24H0z\"></path></clipPath></defs>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }